__turbopack_context__.v({
  "contactBox": "page-module___8aEwW__contactBox",
  "contactEmail": "page-module___8aEwW__contactEmail",
  "grantInfo": "page-module___8aEwW__grantInfo",
  "hero": "page-module___8aEwW__hero",
  "heroContent": "page-module___8aEwW__heroContent",
  "heroCta": "page-module___8aEwW__heroCta",
  "heroDescription": "page-module___8aEwW__heroDescription",
  "heroSubtitle": "page-module___8aEwW__heroSubtitle",
  "heroTitle": "page-module___8aEwW__heroTitle",
  "highlight": "page-module___8aEwW__highlight",
  "infoBox": "page-module___8aEwW__infoBox",
  "logo": "page-module___8aEwW__logo",
  "logosGrid": "page-module___8aEwW__logosGrid",
  "logosSection": "page-module___8aEwW__logosSection",
  "orcidIcon": "page-module___8aEwW__orcidIcon",
  "orcidLink": "page-module___8aEwW__orcidLink",
  "orcidPlaceholder": "page-module___8aEwW__orcidPlaceholder",
  "page": "page-module___8aEwW__page",
  "projectInfo": "page-module___8aEwW__projectInfo",
  "statItem": "page-module___8aEwW__statItem",
  "statLabel": "page-module___8aEwW__statLabel",
  "statNumber": "page-module___8aEwW__statNumber",
  "statsCounter": "page-module___8aEwW__statsCounter",
  "teamBlock": "page-module___8aEwW__teamBlock",
  "teamSection": "page-module___8aEwW__teamSection",
});
